import { useNavigate } from "react-router";
import licenseService from "../../../core/services/metaStoreService/license-service";
import { StriimTypography, StriimLink } from "@striim/striim-ui-v2";

export const homePageInfo = (sourceName, isAppAdapterLicense) => {
    const navigate = useNavigate();

    return {
        SQL2FABRICSOLUTION: {
            imgsrc: licenseService.isLiteLicense
                ? "src/modules/apps/pages/homepage/resources/images/2-items.png"
                : "src/modules/apps/pages/homepage/resources/images/3-items.png",
            imgstyle: {
                width: licenseService.isLiteLicense ? "630px" : "100%"
            },
            imgDesc: licenseService.isLiteLicense ? (
                <StriimTypography variant="body3" color={"greyscale.900"}>
                    <sup>*</sup>
                    {"Fabric Data Warehouse & Databricks Require a Standard Plan"}
                    <StriimLink href={"https://urlr.me/!sql2fabric"} target="_blank" sx={{ p: 0, top: -1 }}>
                        Upgrade
                    </StriimLink>
                </StriimTypography>
            ) : null,
            button: "Create Pipeline",
            buttonOnClick: function() {
                licenseService.isLiteLicense
                    ? navigate("/create-app/sql2Fabric?source=SQL+Server&target=Fabric+Mirroring")
                    : navigate("/create-app/sql2Fabric?source=SQL+Server");
            },
            welcomeMsgInfo: {
                desc: licenseService.isLiteLicense
                    ? "Replicate your SQL Server database to Fabric Mirrored database in a few clicks"
                    : "Replicate your SQL Server database to Fabric Mirrored database, Fabric Data Warehouse or Databricks in a few clicks",
                titleVariant: "h3"
            },
            exploreInfo: {
                title: "Learn more about replicating your data using SQL2Fabric-X",
                videoContainerStyle: {
                    display: "flex"
                }
            }
        },
        DEFAULT: {
            description:
                "Apps are data pipelines that help you stream data from various sources to targets. Get started by building an App using one of our pre-configured wizards, by importing a TQL or start from scratch using the flow designer.",
            imgsrc: "src/modules/apps/pages/homepage/resources/images/homepage-woman.svg",
            button: "Create an App",
            buttonOnClick: function() {
                navigate("/create-app");
            },
            welcomeMsgInfo: {
                desc: `Create your first ${sourceName} App ${isAppAdapterLicense ? "(Pipeline)" : ""}`
            },
            exploreInfo: {
                title: "Learn more about the Striim Platform"
            }
        }
    };
};
